export const getOS = () => {
  const ua = navigator.userAgent;

  return {
    isWindows: /Windows/i.test(ua),
    isMac: /Macintosh|Mac OS X/i.test(ua),
    isIOS: /iPhone|iPad/i.test(ua),
    isLinux: /Linux/i.test(ua) && !/Android/i.test(ua),
    isAndroid: /Android/i.test(ua),
  };
};
